import { useState } from "react";
import { works } from "@/mocks/comics";

const FORM_URL = "https://readdy.ai/api/form/da233rjk8r5te5mqsf70";

type FormStatus = "idle" | "success" | "error";

export default function SubscribeForm() {
  const [status, setStatus] = useState<FormStatus>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    // 蜜罐字段：若被机器人填入，则静默当作成功处理
    const honeypot = (formData.get("contact_alt") || "").toString().trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功！我们将第一时间为你推送更新动态。");
      form.reset();
      return;
    }
    formData.delete("contact_alt");

    setStatus("idle");
    setMessage("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || "";
      const isOk = res.ok && parsed?.code === "OK";
      if (isOk && !serverMsg.toLowerCase().includes("spam")) {
        setStatus("success");
        setMessage("订阅成功！最新章节更新时，我们会第一时间推送提醒给你。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          serverMsg && !serverMsg.toLowerCase().includes("spam")
            ? serverMsg
            : "提交失败，请稍后重试。",
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  };

  return (
    <form
      id="subscribe-form"
      data-readdy-form="追更提醒订阅"
      onSubmit={handleSubmit}
      noValidate
      className="mx-auto w-full max-w-2xl"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-stretch">
        <div className="flex flex-1 items-center gap-2 rounded-xl bg-background-50 px-4 py-1 ring-1 ring-background-200 focus-within:ring-2 focus-within:ring-primary-400">
          <i className="ri-mail-line text-lg text-primary-600" aria-hidden="true" />
          <input
            type="email"
            name="email"
            required
            placeholder="输入你的邮箱，接收最新章节提醒"
            autoComplete="email"
            className="w-full bg-transparent py-2.5 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
          />
        </div>
        <select
          name="works"
          defaultValue=""
          className="rounded-xl bg-background-50 px-4 py-3 text-sm text-foreground-700 ring-1 ring-background-200 outline-none focus:ring-2 focus:ring-primary-400"
        >
          <option value="">选择你想追更的作品（可选）</option>
          {works.map((w) => (
            <option key={w.id} value={w.title}>
              {w.title}
            </option>
          ))}
        </select>
        <button
          type="submit"
          className="whitespace-nowrap rounded-xl bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 focus:ring-2 focus:ring-primary-400"
        >
          立即订阅
        </button>
      </div>

      {/* 蜜罐字段：隐藏，防止机器人提交 */}
      <input
        type="text"
        name="contact_alt"
        className="hp-field"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <p className="mt-3 text-xs text-background-100/90">
        订阅完全免费，可随时取消 · 我们不会向第三方泄露你的邮箱
      </p>

      {status === "success" && (
        <div className="mt-4 flex items-center gap-2 rounded-lg bg-background-100/20 px-4 py-3 text-sm text-background-50">
          <i className="ri-checkbox-circle-line text-lg" aria-hidden="true" />
          {message}
        </div>
      )}
      {status === "error" && (
        <div className="mt-4 flex items-center gap-2 rounded-lg bg-red-300/25 px-4 py-3 text-sm text-red-200">
          <i className="ri-error-warning-line text-lg" aria-hidden="true" />
          {message}
        </div>
      )}
    </form>
  );
}